import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import SearchBar from "../../components/SearchBar";
import AddPreferredPartner from "../../Modals/addpreferredpartner";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const ViewSubscription = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
  

    // Example user data
    const [userData, setUserData] = useState([
        {
            id: "#USR001",
            name: "John Doe",
            email: "john@example.com",
            phone: "+91 9876543210",
            status: "Ongoing",
            purchaseCount: 5,
            purchaseDate: "05 Oct 2025",
        },
        {
            id: "#USR002",
            name: "Alice Smith",
            email: "alice@example.com",
            phone: "+91 9123456789",
            status: "Expired",
            purchaseCount: 2,
            purchaseDate: "01 Oct 2025",
        },
        {
            id: "#USR003",
            name: "Bob Williams",
            email: "bob@example.com",
            phone: "+91 9988776655",
            status: "Ongoing",
            purchaseCount: 7,
            purchaseDate: "08 Oct 2025",
        },
    ]);

    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const subscriptionDetails = {
        subscriptionType: "Premium",
        planName: "Professional",
        monthlyPrice: "$79",
        annualPrice: "$790",
        trialDays: 14,
        description: "Perfect for growing businesses with advanced needs.",
        features: [
            "Unlimited products",
            "Advanced analytics",
            "Priority support",
            "Custom templates",
            "AI product descriptions",
            "Multi-channel selling",
        ],
        queriesLimit: "10000",
        status: true,
        createdDate: "10 Oct 2025",
    };

    const topPerformer = [...userData].sort(
        (a, b) => b.purchaseCount - a.purchaseCount
    )[0];


    return (
        <>
            <div className="main_title">
                <h1>Subscription Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/subscriptions")}>
                        Manage Subscriptions
                    </button>{" "}
                    - View Subscription
                </p>
            </div>
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    aria-label="basic tabs example"
                    className="custom_tabs_links"
                >
                    <Tab label="Subscription Details" {...a11yProps(0)} />
                    <Tab label="Subscribed Users" {...a11yProps(1)} />

                </Tabs>
            </Box>
            <CustomTabPanel value={valueTabs} index={0}>
                <div className="cards">
                    <div className="view_page">
                        <div className="gap_p">
                            <div className="w_33">
                                <h6>Subscription Type</h6>
                                <p>{subscriptionDetails.subscriptionType}</p>
                            </div>

                            <div className="w_33">
                                <h6>Plan Name</h6>
                                <p>{subscriptionDetails.planName}</p>
                            </div>

                            <div className="w_33">
                                <h6>Monthly Price</h6>
                                <p>{subscriptionDetails.monthlyPrice}</p>
                            </div>

                            <div className="w_33">
                                <h6>Annual Price</h6>
                                <p>{subscriptionDetails.annualPrice}</p>
                            </div>

                            <div className="w_33">
                                <h6>Trial Days</h6>
                                <p>{subscriptionDetails.trialDays} Days</p>
                            </div>

                            <div className="w_33">
                                <h6>Queries Limit</h6>
                                <p>{subscriptionDetails.queriesLimit}</p>
                            </div>

                            <div className="w_33">
                                <h6>Status</h6>
                                <p>
                                    <SwitchToggle checked={subscriptionDetails.status} />
                                </p>
                            </div>

                            <div className="w_33">
                                <h6>Created Date</h6>
                                <p>{subscriptionDetails.createdDate}</p>
                            </div>

                            <div className="w_100">
                                <h6>Description</h6>
                                <p>{subscriptionDetails.description}</p>
                            </div>

                            <div className="w_100">
                                <h6>Features</h6>
                                <ul className="inline_tags">
                                    {subscriptionDetails.features.map((feature, i) => (
                                        <li key={i}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={1}>
                <div className="stats_boxes gap_m">
                    <div className="cards">
                        <small>Top Performer</small>
                        <div className="data_top">
                            <h2>
                                {topPerformer.purchaseCount}
                                <p>Purchases</p>
                            </h2>
                            <figure className="sucess">
                                <img src="/static/images/user_icon.svg" alt="Top Performer" />
                            </figure>
                        </div>

                        <div className="rating_box">
                            <p>
                                <b>{topPerformer.name}</b>


                            </p>
                        </div>
                    </div>
                </div>

                <div className="cards mt_20">
                    <div className="table_header">
                        <div className="left_s">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search Subscription Plans..."
                            />
                        </div>

                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No.</TableCell>
                                    <TableCell>User Details</TableCell>
                                    <TableCell>Purchase Date</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>


                            <TableBody>
                                {userData
                                    .filter((user) =>
                                        user.name.toLowerCase().includes(searchTerm.toLowerCase())
                                    )
                                    .map((user, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{index + 1}</TableCell>

                                            <TableCell>
                                                <div className="user_block">
                                                    <figure>
                                                        <img
                                                            src="/static/images/user_placeholder.png"
                                                            alt="User"
                                                        />
                                                    </figure>
                                                    <p>
                                                        <b>{user.name}</b>
                                                        {user.email}
                                                        <br />
                                                        {user.phone}
                                                    </p>
                                                </div>
                                            </TableCell>

                                            <TableCell>{user.purchaseDate}</TableCell>

                                            <TableCell>
                                                <span className={`status ${user.status.toLowerCase()}`}>
                                                    {user.status}
                                                </span>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>

                        </Table>
                    </TableContainer>


                </div>
            </CustomTabPanel>
            <AddPreferredPartner open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />

        </>
    );
};

export default ViewSubscription;
